import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

// UTILITY
import { trimCharacters } from '@/utility/common';

const ZipCodeInput = React.forwardRef(({ onChange, ...props }, ref) => {
  const handleChange = event => {
    event.target.value = trimCharacters(event.target.value);

    onChange(event);
  };

  return <TextField ref={ref} onChange={handleChange} {...props} />;
});

ZipCodeInput.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default ZipCodeInput;
